const smallFeatures = [
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '1080P 与 4K 蓝光画质，逐帧优化，画面通透细腻。',
    tone: 'accent',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速播放',
    desc: '智能线路调度，秒开秒播不卡顿，弱网也顺滑。',
    tone: 'secondary',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '手机、平板、电视无缝切换，进度自动云同步。',
    tone: 'primary',
  },
  {
    icon: 'ri-download-2-line',
    title: '离线缓存',
    desc: '支持批量缓存下载，没网也能继续追剧。',
    tone: 'accent',
  },
  {
    icon: 'ri-sparkling-line',
    title: '智能推荐',
    desc: '根据你的观影口味精准推荐，越用越懂你。',
    tone: 'secondary',
  },
];

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

const categories = ['电影', '电视剧', '综艺', '动漫', '纪录片'];

export default function GuaziFeatures() {
  return (
    <section id="features" className="guazi-anchor w-full bg-background-100 pt-20 md:pt-28 pb-16 md:pb-24 px-4 md:px-6">
      <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs md:text-sm font-bold">
          <i className="ri-star-smile-line text-base" />
          功能特色
        </span>
        <h2 className="mt-4 font-heading font-extrabold text-3xl md:text-4xl text-foreground-950">
          从点开到看完，每一步都替你想到
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-7">
          片源、画质、播放、缓存层层打磨，瓜子影视只想让你看得爽、看得久。
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
        {/* 主推大卡片 */}
        <div className="lg:col-span-2 relative overflow-hidden rounded-lg bg-primary-500 p-6 md:p-9 flex flex-col justify-between min-h-[280px] md:min-h-[320px]">
          <div className="relative z-10">
            <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg bg-primary-950/10">
              <i className="ri-film-line text-3xl md:text-4xl text-primary-950" />
            </span>
            <h3 className="mt-5 font-heading font-extrabold text-2xl md:text-3xl text-primary-950">
              海量片库，一网打尽
            </h3>
            <p className="mt-3 text-sm md:text-base leading-7 text-primary-950/80 max-w-md">
              电影、电视剧、综艺、动漫、纪录片一应俱全，热门资源持续更新，想看的内容随时都在。
            </p>
          </div>
          <div className="relative z-10 mt-6 flex flex-wrap gap-2">
            {categories.map((c) => (
              <span key={c} className="px-3 py-1.5 bg-background-50/85 text-primary-900 rounded-full text-xs md:text-sm font-bold whitespace-nowrap">
                {c}
              </span>
            ))}
          </div>
          <img
            src="/images/guazi-app-icon.png"
            alt="瓜子影视软件图标"
            title="瓜子影视APP下载官网"
            className="hidden md:block absolute -right-6 -bottom-8 w-52 opacity-20 rotate-6"
          />
        </div>

        {/* 右侧两张堆叠 */}
        <div className="flex flex-col gap-5 md:gap-6">
          {smallFeatures.slice(0, 2).map((item) => (
            <div
              key={item.title}
              className="flex-1 bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors duration-200"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg ${toneMap[item.tone]}`}>
                <i className={`${item.icon} text-2xl`} />
              </div>
              <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-6">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* 底部三张横排 */}
        <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
          {smallFeatures.slice(2).map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-4 bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors duration-200"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-lg shrink-0 ${toneMap[item.tone]}`}>
                <i className={`${item.icon} text-2xl`} />
              </span>
              <div>
                <h3 className="font-heading font-bold text-lg text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-6">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}